'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<g fill="none" fill-rule="evenodd" transform="translate(0 -3)"><path d="M0 0h22v22H0z"/><path id="-a-0-13521" d="M4.853 19a8.206 8.206 0 0 1-.013-.47c0-2.69 1.313-5.03 3.245-6.22-1.17-.946-1.925-2.445-1.925-4.134C6.16 5.318 8.327 3 11 3s4.84 2.318 4.84 5.176c0 1.689-.756 3.188-1.925 4.133 1.932 1.192 3.245 3.53 3.245 6.22 0 .159-.005.315-.013.471H4.853zm17.126-1.882h-3.993a7.762 7.762 0 0 0-1.585-3.889c.172-.152.356-.285.55-.398a2.883 2.883 0 0 1-1.111-2.302c0-1.559 1.182-2.823 2.64-2.823 1.458 0 2.64 1.264 2.64 2.823 0 .95-.438 1.79-1.11 2.302 1.177.685 1.99 2.136 1.99 3.816 0 .16-.007.316-.021.47zm-21.958 0a5.144 5.144 0 0 1-.021-.47c0-1.68.813-3.132 1.99-3.817A2.883 2.883 0 0 1 .88 10.53c0-1.559 1.182-2.823 2.64-2.823 1.458 0 2.64 1.264 2.64 2.823 0 .95-.438 1.79-1.11 2.302a3.5 3.5 0 0 1 .549.398 7.762 7.762 0 0 0-1.585 3.889H.021z" fill="#000"/></g><!-- Filename: sourceSvg/account/group_v2_selected.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 22 16'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};